import { Dispatch } from '../../../store/store';

export const mapDispatch = (dispatch: Dispatch) => ({
  getListChannelFaults: dispatch.channels.getListChannelFaults,
});
